import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { filter, tap, take } from 'rxjs/operators';
import { RouterEvent, NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'app-dialog-status-message',
  templateUrl: './dialog-status-message.component.html',
  styleUrls: ['./dialog-status-message.component.sass'],
})
export class DialogStatusMessageComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DialogStatusMessageComponent>,
    router: Router
  ) {
    // Close dialog ref on route changes
    router.events
      .pipe(
        filter((event: RouterEvent) => event instanceof NavigationStart),
        tap(() => this.dialogRef.close()),
        take(1)
      )
      .subscribe();
  }

  ngOnInit() {}

  close() {
    this.dialogRef.close();
  }
}
